"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.overlayService = void 0;
var app_1 = require("app");
var OverlayService = /** @class */ (function () {
    function OverlayService() {
        var _this = this;
        this.isOverlayVisible = false;
        this.header = document.querySelector('.header');
        this.fixedClassName = 'fixed';
        this.enableBodyScrollLock = function () {
            var scrollPosition = window.scrollY;
            _this.addScrollBarPlaceholder();
            document.body.classList.add(_this.fixedClassName);
            document.body.style.top = "-".concat(scrollPosition, "px");
            _this.isOverlayVisible = true;
        };
        this.disableBodyScrollLock = function () {
            var scrollPosition = document.body.style.top;
            document.body.classList.remove(_this.fixedClassName);
            _this.removeScrollBarPlaceholder();
            document.body.style.top = '';
            if (scrollPosition && window.scroll) {
                window.scroll(0, parseInt(scrollPosition) * -1);
            }
            setTimeout(function () {
                _this.isOverlayVisible = false;
            }, 150);
        };
        this.addScrollBarPlaceholder = function () {
            var offset = window.innerWidth - app_1.UtilService.getElementWidthWithoutPaddings(document.body);
            if (offset > 0) {
                document.body.style.paddingRight = "".concat(offset, "px");
            }
            if (_this.header && offset > 0) {
                _this.header.style.right = "".concat(offset, "px");
            }
        };
        this.removeScrollBarPlaceholder = function () {
            document.body.style.paddingRight = '';
            if (_this.header) {
                _this.header.style.right = '';
            }
        };
        this.removeBodyOverflow = function () {
            document.body.style.removeProperty('overflow');
        };
    }
    return OverlayService;
}());
exports.overlayService = new OverlayService();
